import { Component, EventEmitter, Input, Output } from "@angular/core";
import { InvoiceService } from "../../invoice.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../auth/service";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-invoice-file-attachments",
  templateUrl: "./invoice-file-attachments.component.html"
})
export class InvoiceFileAttachmentsComponent {

  @Input() invoiceForm: FormGroup;
  @Input() existingAttachments: { id: number; url: string; filename: string }[] = [];

  @Output() changeAttachmentsList = new EventEmitter();

  attachments_list_obj: any = [];
  attachments_list: any = [];

  constructor(
    public _invoiceService: InvoiceService,
    private _authService: AuthenticationService,
    public _utilsService: UtilsService
  ) {
  }

  async addAttachmentToList(files: any) {
    // I create a variable from the actual list
    let updatedList: any[] = this.attachments_list_obj.filter((item: any) => item.name !== "");
    //For all files charged in the queue
    for (let file of files) {
      //check dimensions
      if (file.size > 10000000) {
        await this._utilsService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //If exits in the list I'll remove it
      const exists: any = updatedList.find((item: any) => item.name === file.name);
      // If exists remove it
      if (exists) {
        updatedList = updatedList.find((item: any) => item.name === file.name);
      }
      //If it does not exist I'll add it
      else {
        this.attachments_list.push(file);
      }
      //Add to updated list
      updatedList.push({
        name: file.name,
        size: this._utilsService.formatBytes(file.size),
        status: 0
      });
    }
    //I update the variable for the page
    this.attachments_list_obj = updatedList;
    this.changeAttachmentsList.emit(this.attachments_list)
  }

  resetAttachmentsList() {
    this.attachments_list_obj = [];
    this.attachments_list = [];
    this.changeAttachmentsList.emit([])
  }

  removeAttachmentFromList(index: any) {
    this.attachments_list_obj = this.attachments_list_obj.filter((item: any, i: number) => i !== index);
    this.attachments_list = this.attachments_list.filter((item: any, i: number) => i !== index);
    this.changeAttachmentsList.emit(this.attachments_list)
  }

  async deleteFile(file: { id: number; url: string; filename: string }) {
    if (!this._authService.hasCapability("delete_invoice_order")) {
      this._utilsService.hideLoading();
      return false;
    }
    return this._invoiceService.deleteAttachedFile(file)
      .then((result) => {
        if (result) {
          this.existingAttachments = this.existingAttachments.filter((a: any) => a.id !== file.id);
        }
      });
  }


}
